import { render, staticRenderFns } from "./FileDetailView.vue?vue&type=template&id=0e2ff4e5&scoped=true&"
import script from "./FileDetailView.vue?vue&type=script&lang=js&"
export * from "./FileDetailView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=0e2ff4e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2ff4e5",
  null
  
)

export default component.exports